<template>
    <div>
        <div class="contentbox" v-loading="loading">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/product' }">产品系列</el-breadcrumb-item>
                <el-breadcrumb-item>{{ data.title }}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-divider></el-divider>
            <div class="content">
                <p style="width: 25%">
                    <el-image style="width: 100%; height: 240px" :src="data.img" fit="fill"></el-image>
                </p>
                <div class="right">
                    <p>{{ data.title }}</p>
                    <p style="font-size: 14px;font-weight: normal;text-indent: 2em;line-height: 30px;">{{ data.effect }}
                    </p>
                </div>
            </div>
            <p style="color: #666;font-weight: bold;font-size: 14px">产品详细说明</p>
            <el-divider></el-divider>
            <p class="login" @click="login" v-show="!islogin">付费后显示全文</p>
            <div style="text-align: center;" v-show="islogin">
                <el-image v-for="(item, index) in data.particulars" :src="item"></el-image>
            </div>
        </div>
        <el-divider></el-divider>
        <div class="footer">
            <ul class="putbox">
                <li>芙清fulqun官网</li>
                <li>Beijing FulQun Bio-Technology Co. Ltd</li>
                <li>北京芙清生物科技有限公司©</li>
                <li>地址：北京市丰台区南四环西路186号汉威国际广场二区9号楼6层03-07室</li>
                <li>
                    <a href="https://beian.miit.gov.cn/">京ICP备19037671号-1</a>
                </li>
                <li @click="() => { this.$router.push('/img') }">
                    互联网药品信息服务资格证书
                </li>
            </ul>
            <div class="contactbox">
                <p>400-010-2266</p>
                <p>周一至周五 9:00-17:30</p>
                <p>在线客服</p>
            </div>
        </div>
        <el-dialog title="扫码付款" :visible.sync="dialogVisible" width="280px" @close="dialogClose">
            <img src="@/assets/images/3.png" alt />
            <span slot="footer" class="dialog-footer">
                <el-button @click="close(0)" size="mini">取消支付</el-button>
                <el-button type="primary" @click="close(1)" size="mini">完成支付</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: {

            },
            islogin: false,
            loading: false,
            dialogVisible: false,
            ispay: false
        };
    },
    created() {
        // 判断是否存在页面缓存
        if (window.sessionStorage.getItem('_data')) {
            this.data = JSON.parse(window.sessionStorage.getItem('_data'));
            setTimeout(() => {
                window.sessionStorage.removeItem('_data');
            }, 50);
        } else {
            if (this.$route.query.data.title) {
                this.data = this.$route.query.data;
                window.sessionStorage.setItem('data', JSON.stringify(this.data));
            } else if (window.sessionStorage.getItem('data')) {
                this.data = JSON.parse(window.sessionStorage.getItem('data'));
                this.islogin = window.sessionStorage.getItem('islogin');
            }
        }

    },
    destroyed() {
        window.sessionStorage.removeItem('data');
        window.sessionStorage.removeItem('islogin');
    },
    methods: {
        go() {
            this.$router.push('/certification')
        },
        login() {
            // 判断是否登录
            if (window.sessionStorage.getItem('username')) {
                this.dialogVisible = true; return;
            }
            // 未登录
            window.sessionStorage.setItem('_data', JSON.stringify(this.data));
            this.$router.push('/login');
        },
        close(i) {
            this.ispay = i == 1 ? true : false;
            this.dialogVisible = false;
        },
        dialogClose() {
            if (this.ispay == 1) {
                window.sessionStorage.setItem("islogin", true);
                this.loading = true;
                setTimeout(() => {
                    this.islogin = true;
                    this.loading = false;
                }, 1000);
            }
        }
    },
};
</script>

<style lang="less" scoped>
.contentbox {
    width: 1200px;
    margin: auto;
    padding: 20px 0;
}

.content {
    display: flex;
    justify-content: space-between;
}

.right {
    width: 75%;
    padding: 0 30px;
}

.right p {
    font-weight: bold;
    color: #666;
}

.right div {
    display: flex;
}

.right div p {
    background-color: #ddd;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    width: 100px;
    height: 30px;
    margin-right: 10px;
    cursor: pointer;
}

.login {
    width: 150px;
    height: 30px;
    margin: auto;
    margin-bottom: 20px;
    color: cornflowerblue;
    border: 1px solid cornflowerblue;
    font-size: 12px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
}

.footer {
    height: 200px;
    padding: 30px;
    background-color: rgb(250, 250, 250);
    display: flex;
    justify-content: space-between;
}

.putbox {
    list-style: none;
    font-size: 12px;
    width: 70%;
    margin-top: 10px;
    padding-left: 10%;
    line-height: 30px;
}

.putbox a {
    text-decoration: none;
    color: #666;
}

.contactbox {
    width: 30%;
    height: 100%;
    text-align: center;
    line-height: 50px;
}

.contactbox p:nth-child(1) {
    color: rgb(65, 110, 179);
    font-size: 28px;
}

.contactbox p:nth-child(2) {
    font-size: 14px;
    color: #666;
}

.contactbox p:nth-child(3) {
    width: 180px;
    height: 36px;
    margin: auto;
    border: 1px solid rgb(65, 110, 179);
    color: rgb(65, 110, 179);
    line-height: 36px;
    cursor: pointer;
}
</style>
